import { Select } from '@mantine/core';
import { ReportInterval } from '../../types/reports';
import { periodOptions } from '../evaluations/periodFilterModel';

/**
 * Der kleine Bruder von `PeriodFilter.tsx` (Auswertungsseiten) fuer die Meldungenseite (D-07,
 * D-18). Drei bewusste Abgrenzungen zum Vorbild:
 *
 * - kein Abruf der pro Jahr tatsaechlich verfuegbaren Meldejahre -- die Jahresgrenzen sind fest
 *   (D-02/D-04, `REPORT_YEAR_RANGE_START`/`currentReportYear()` in `reportYearRange.ts`), nicht
 *   datengetrieben
 * - kein eigener Jahres-Picker -- das Jahr steht bereits als eigenes Feld in der Leiste (D-09,
 *   `ReportFilters.tsx`)
 * - keine YTD-Zeile -- die gibt es nur auf den Auswertungsseiten
 *
 * Reine, zustandslose Darstellungskomponente: keine URL-Anbindung, kein Datenabruf, kein eigener
 * Zustand. Der Optionskatalog kommt unveraendert aus `periodOptions()` (Bestand aus Phase 22) --
 * damit bietet der Selektor alle Perioden des Intervalls an (12 Monate bzw. 4 Quartale), nicht
 * nur belegte (D-18).
 */
interface ReportPeriodSelectorProps {
  interval: ReportInterval;
  value: string | undefined;
  onChange: (period: string | undefined) => void;
  disabled?: boolean;
}

export function ReportPeriodSelector({
  interval,
  value,
  onChange,
  disabled,
}: ReportPeriodSelectorProps) {
  const handleChange = (next: string | null) => {
    if (!next || next === 'all') {
      onChange(undefined);
      return;
    }
    onChange(next);
  };

  return (
    <Select
      placeholder={interval === ReportInterval.QUARTERLY ? 'Quartal' : 'Monat'}
      data={periodOptions(interval)}
      value={value ?? 'all'}
      onChange={handleChange}
      disabled={disabled}
      clearable
    />
  );
}
